import { useGetFolderDataQuery, useGetFoldersQuery } from "../../queries/query-selectors/tagger-query-selectors";
import { useTaggerDealIdSelector, useTaggerDocumentSelector } from "../../store";

const useFolders = ({
  folderId,
  docId,
  withOptions = false,
  dealId
}: {
  folderId?: number;
  docId?: number;
  withOptions?: boolean;
  dealId?: number;
}) => {
  const document = useTaggerDocumentSelector(docId || 0) || null;
  const stateDealId = useTaggerDealIdSelector();

  const effectiveFolderId = folderId || document?.data?.selectedFolder;
  const effectiveDealId = dealId || stateDealId;
  const { data: folders = [], isLoading: foldersLoading } = useGetFoldersQuery(withOptions ? effectiveDealId : null);
  const { data: folderData = null, isLoading: folderDataLoading } = useGetFolderDataQuery(effectiveFolderId);

  const folderOptions = folders
    .filter((folder) => ["folder"].includes(folder.kind))
    .map(({ id, title }) => ({
      label: title,
      value: id
    }));

  return {
    options: withOptions ? folderOptions : [],
    value: folderData ?? null,
    loading: folderDataLoading || foldersLoading,
    onChange: () => {} //unused
  };
};

export default useFolders;
